<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.signStatus"
          placeholder="签收状态"
        >
          <el-option
            v-for="(item, i) in signStatus"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.userName"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      signStatus: [],
    };
  },
  created() {
    this.getSysParamByTypes(["IS_SIGN"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["IS_SIGN"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.signStatus = res.data["IS_SIGN"];
      });
    },
    query() {
      this.$emit("search", { ...this.filters });
    },
    reset() {
      this.filters = {};
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
  